import documentfilesReducer from "./reducers";
export { default as documentfilesTypes } from "./types";
export { default as documentfilesOperations } from "./operations";
export default documentfilesReducer;
